// extracted by mini-css-extract-plugin
export default {"base_button":"BaseButton_base_button__8FzoJ","loading_spinner":"BaseButton_loading_spinner__uhfjG"};